import React, { useMemo } from 'react';

import { EmployeeMatchingType } from '@/modules/employer/components/Lockbox/lockbox.types';
import { SuccessMessage, WarningMessage } from '@/modules/employer/components/Lockbox/LockboxDetails/components/LockboxInfo/LockboxMatchingList';

interface Props {
  matchingType?: EmployeeMatchingType;
}

const EmployeeMatchingMessage: React.FC<Props> = ({ matchingType }) => {
  const message = useMemo(() => {
    switch (matchingType) {
    case EmployeeMatchingType.ACCOUNT_NOT_FOUND: {
      return <WarningMessage title="HSA Doesn’t Exist" />;
    }
    case EmployeeMatchingType.ACCOUNT_NOT_MATCHED: {
      return <WarningMessage title="HSA Account Number Doesn’t Match" />;
    }
    case EmployeeMatchingType.EMPLOYEE_NAME_NOT_MATCHED: {
      return <WarningMessage title="Employee Name Doesn’t Match" />;
    }
    case EmployeeMatchingType.FULL_MATCH: {
      return <SuccessMessage title="All Data Matched" />;
    }
    case EmployeeMatchingType.SSN_NOT_MATCHED: {
      return <WarningMessage title="SSN Doesn’t Match" />;
    }
    case EmployeeMatchingType.LINKED_EMPLOYEE: {
      return <SuccessMessage title="Employee's HSA has been orphaned. Employer sponsored HSA has been closed." />;
    }
    case EmployeeMatchingType.INVESTMENTS_TO_BE_LIQUIDATED: {
      return <WarningMessage title="Investments to be Liquidated" />;
    }
    case EmployeeMatchingType.ADDRESS_NOT_MATCHED: {
      return <WarningMessage title="Address Was Not Matched" />;
    }
    case EmployeeMatchingType.COMMUNICATION_NOT_MATCHED: {
      return <WarningMessage title="Communication Was Not Matched" />;
    }
    default: {
      return null;
    }
    }
  }, [matchingType]);

  return message;
};

export default EmployeeMatchingMessage;
